import { render, staticRenderFns } from "./refresh.vue?vue&type=template&id=cf0aa54a&"
import script from "./refresh.vue?vue&type=script&lang=js&"
export * from "./refresh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf0aa54a')) {
      api.createRecord('cf0aa54a', component.options)
    } else {
      api.reload('cf0aa54a', component.options)
    }
    module.hot.accept("./refresh.vue?vue&type=template&id=cf0aa54a&", function () {
      api.rerender('cf0aa54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/refresh.vue"
export default component.exports